export enum PanelType {
    smallFluid = 0,
    smallFixedNear,
    medium,
    large,
    largeFixed,
    extraLarge,
}
